export default "__VITE_ASSET__D4QM452w__"